import { render } from "./DependentsProfile.vue?vue&type=template&id=c2bdbaa4&scoped=true&ts=true"
import script from "./DependentsProfile.vue?vue&type=script&lang=ts"
export * from "./DependentsProfile.vue?vue&type=script&lang=ts"

import "./DependentsProfile.vue?vue&type=style&index=0&id=c2bdbaa4&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2bdbaa4"]])

export default __exports__